// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D3vM","top":"styles_top__S_aLs"};